var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    viewBox: "0 0 65 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8207 0C56.1696 0 64.5877 8.41809 64.5877 18.7701V41.2299C64.5877 51.5788 56.1696 60 45.8207 60H18.7701C8.42122 60 0 51.5788 0 41.2299V18.7701C0 8.41809 8.42122 0 18.7701 0H45.8207ZM45.8207 4.6941H18.7701C11.0092 4.6941 4.6941 11.0092 4.6941 18.7701V41.2299C4.6941 48.9908 11.0092 55.3059 18.7701 55.3059H45.8207C53.5816 55.3059 59.8936 48.9908 59.8936 41.2299V40.3536L49.5732 40.3555C43.6367 40.3555 38.8049 35.5268 38.8018 29.5935C38.8018 23.6539 43.6335 18.8221 49.5732 18.819L59.8936 18.8171V18.7701C59.8936 11.0092 53.5816 4.6941 45.8207 4.6941ZM59.8936 23.5112L49.5732 23.5131C46.2216 23.5162 43.4959 26.2419 43.4959 29.5904C43.4959 32.9357 46.2247 35.6614 49.5732 35.6614L59.8936 35.6595V23.5112ZM51.0052 27.0493C52.3007 27.0493 53.3522 28.1008 53.3522 29.3963C53.3522 30.6919 52.3007 31.7434 51.0052 31.7434H50.0288C48.7332 31.7434 47.6817 30.6919 47.6817 29.3963C47.6817 28.1008 48.7332 27.0493 50.0288 27.0493H51.0052ZM33.4376 14.2015C34.7332 14.2015 35.7847 15.253 35.7847 16.5486C35.7847 17.8442 34.7332 18.8956 33.4376 18.8956H16.542C15.2464 18.8956 14.195 17.8442 14.195 16.5486C14.195 15.253 15.2464 14.2015 16.542 14.2015H33.4376Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.df54b73b7e517ba9e09e82fe0817af32.svg";
export { ForwardRef as ReactComponent };